import React, { useState } from 'react'

import Header from '../components/header';
import Footer from '../components/footer';
import { Helmet } from 'react-helmet'

export default function KnowlegdeCheck() {
  let [topics, setTopic] = useState('');
  let [questions, setQuestions] = useState([]);
  let [check, setCheck] = useState(false);
  let [show, setShow] = useState(false);
  let [index, setIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState(Array(25).fill(null));
  let [result, setTotalResult] = useState(Array(25).fill(false));
  let [final, setFinal] = useState(0);
  const cleanJsonString = (str) => {
    if (!str) return '';
    // Remove Markdown code block syntax and any other non-JSON text
    return str.replace(/```json|```/g, '').trim();
  };
  let getData = async () => {
    setShow(true);
    const prompt = `Generate a JSON object with 25 multiple-choice questions about these topics: ${topics}. Format:
                {
                    "questions": [
                        {
                            "question": "Question text",
                            "options": ["Option 1", "Option 2", "Option 3", "Option 4"],
                            "correctAnswer": 0 // index of correct option
                        }
                    ]
                }
                Include questions of varying difficulty covering all mentioned topics and ensure the correct answer is always one of the options remeber i only need json no extra text return json only even font say here is json .`;

    const response = await fetch('https://toolisobackend.vercel.app/gemini', {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt })
    });
    const newdata = await response.json();
    let rawData = newdata.candidates?.[0]?.content?.parts?.[0]?.text;
    let clearText = cleanJsonString(rawData);
    const parsed = JSON.parse(clearText);
    setQuestions(parsed.questions || []);
    setShow(false);
    setCheck(true);
    setIndex(0);


  }

  const handleCounter = (selectedIndex, correctAnswer) => {
    const updatedSelections = [...selectedOptions];
    updatedSelections[index] = selectedIndex;
    setSelectedOptions(updatedSelections);

    if (selectedIndex == correctAnswer) {
      const updateResult = [...result];
      updateResult[index] = true;
      setTotalResult(result = updateResult);
    }
    let count = 0;
    for (let i = 0; i < 25; i++) {
      if (result[i] == true) {
        count++;
      }
    }
    setFinal(final = count);


  };



  return (
    <div>
      <Helmet>
  <html lang="en" />
  <title>AI Quiz Generator – Create MCQ Quizzes Instantly | Tooliso</title>
  <meta
    name="description"
    content="Generate personalized multiple-choice quizzes from any topic using AI. Great for students, teachers, and self-learners. Test your knowledge with instant feedback."
  />
  <link rel="canonical" href="https://tooliso.com/KnowledgeCheck" />

  <meta property="og:title" content="AI Quiz Generator – Instantly Create MCQs with AI" />
  <meta
    property="og:description"
    content="Use Tooliso's AI-powered quiz generator to create personalized MCQ quizzes from any topic. Study smarter and track your learning."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://tooliso.com/KnowledgeCheck" />

  <meta name="twitter:card" content="summary" />
  <meta name="twitter:title" content="AI Quiz Generator – Smart Learning Tool | Tooliso" />
  <meta
    name="twitter:description"
    content="Create quizzes instantly from your study material using AI. Tooliso helps you prepare better with auto-generated MCQs and explanations."
  />
</Helmet>
      <Header />

      <div style={{marginTop: "110px", padding: "2rem" }}>
        <div className="Knowlegdeinput-section">
          <h2 className="Knowlegdetitle">AI Quiz Generator</h2>
          <p className="Knowlegdedescription">Enter the topics you've learned to generate a personalized MCQ quiz that tests your understanding.</p>

          <textarea value={topics} onChange={(e) => setTopic(topics = e.target.value)} id="topicsInput" placeholder="Example:
- JavaScript fundamentals (variables, functions, loops)
- CSS concepts (flexbox, grid, animations)
- React hooks (useState, useEffect)
- API integration (fetch, async/await)
..."></textarea>





          {
            show ?
              <div className="outerspin">
                <div className='spinner'></div>
              </div>
              :
              topics==""?
              <button id="generateBtn" className="Knowledgebtn nopoint">
                Generate Quiz
              </button>
              :
              <button onClick={getData} id="generateBtn" className="Knowledgebtn point">
                Generate Quiz
              </button>
          }


        </div>



        <div className="loading" id="loadingIndicator">
          {
            show ?
              <p>Generating your personalized quiz...</p>
              : ""
          }
        </div>
      </div>

      <Footer />
      {
        check ?
          <div class="modal" id="quizModal">
            {
              index !== 25 ?
                questions.map((singleQ, i) => {
                  return (
                    i == index ?
                      <div class="modal-content">
                        <div class="modal-header">
                          <h3 class="modal-title">KnowledgeCheck Quiz</h3>
                          <button class="close-btn" id="closeModal" onClick={() => setCheck(false)}>×</button>
                        </div>

                        <div class="modal-body">
                          <div id="quizContainer">
                            <div class="question-counter">Question {i + 1} of 25</div>
                            <div class="question">{singleQ.question}</div>
                            <div class="options">
                              <div class={`option ${selectedOptions[i] == 0 ? "selected" : ""}`} onClick={() => handleCounter(0, singleQ.correctAnswer)}>A. {singleQ.options[0]}</div>
                              <div class={`option ${selectedOptions[i] == 1 ? "selected" : ""}`} onClick={() => handleCounter(1, singleQ.correctAnswer)}>B. {singleQ.options[1]}</div>
                              <div class={`option ${selectedOptions[i] == 2 ? "selected" : ""}`} onClick={() => handleCounter(2, singleQ.correctAnswer)}>C. {singleQ.options[2]}</div>
                              <div class={`option ${selectedOptions[i] == 3 ? "selected" : ""}`} onClick={() => handleCounter(3, singleQ.correctAnswer)}>D. {singleQ.options[3]}</div>
                            </div>
                            <div class="navigation">
                              {
                                i == 0 ?
                                  <button className='prevfullbtnnew'>Previous</button>
                                  :
                                  <button className={`prevfullbtn ${i === 0 ? "none" : ""}`} onClick={() => setIndex(--index)}>Previous</button>
                              }



                              <button
                                className='nextfullbtn'
                                onClick={() => {
                                  if (selectedOptions[index] === null) {
                                    alert("Please click any choice to proceed to the next question.");
                                  } else {
                                    setIndex(++index);
                                  }
                                }}
                              >
                                Next
                              </button>

                            </div>
                          </div>

                        </div>
                      </div> : ""
                  )
                })
                :
                <div class="modal-content">
                  <div id="resultsContainer" class="results" style={{ zIndex: "2000" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <h3 class="results-title">Quiz Results</h3>
                      <button class="close-btn" id="closeModal" onClick={() => setCheck(false)}>×</button>
                    </div>
                    <div class="score" id="scoreDisplay">
                      <h3 className={`${final<10?"redDes":final>=10&&final<20?"YellowDes":"GreenDes"}`}>{final}/25</h3>
                    </div>

                    <div class="feedback" id="feedback">
                      <p id="feedbackText">
                        {
                          final<10?
                          <p>"Don't give up — every expert was once a beginner!"</p>
                          :
                          
                          final>=10&&final<20?
                           <p>"Great job! You're getting really close to full mastery."</p>
                           :
                            <p>"Excellent job! Your hard work really shows!"</p>
                        }
                      </p>
                    </div>

                    <button class="Knowledgebtn" id="retakeBtn" onClick={()=>setIndex(0)}>Take Another Quiz</button>
                  </div>
                </div>
            }
          </div>

          : ""
      }
    </div>
  )
}
